// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// UAT Merge conflict resolution comment - remove it later.
import { EnvironmentConfig } from './environment.model';

const docsUrl = 'https://devdocs.clear.online/';

export const environment: EnvironmentConfig = {
  envName: 'azure.dev',
  // Set 'production' to FALSE to bypass bridge service and resolve spinner.
  production: true,
  baseUrl: 'https://cmgclear2uiappdev01.azurewebsites.net',
  clear1HostUrl: 'https://retailint.clear.online', // for POC
  clear2DocsUrl: `${docsUrl}`,
  clear2DocsHostUrl: `${docsUrl}iframe-redirect`,
  retail: {
    baseUrl: 'https://cmgclear2apiappdev01.azurewebsites.net',
    apiUrl: 'https://cmgclear2apiappdev01.azurewebsites.net/api/v1',
    autoRecoveryIntervalMs: 5 * 1000, // Auto-Recovery Save Interval in milliseconds
    enableAutoRecovery: true,
    maxAutoRecoveryAttempts: 3,
    newLoanRefreshDelayMS: 5 * 1000,
    activeUsersPollingIntervalMs: 30 * 1000, // Active users polling interval (30 seconds)
    activeUsersHttpFallbackIntervalMs: 10 * 1000, // HTTP fallback polling interval (10 seconds)
    activeUsersHeartbeatIntervalMs: 2 * 60 * 1000, // Heartbeat interval (2 minutes)
    activeUsersJoinThrottleMs: 2 * 1000, // Join notification throttle (2 seconds)
  },
  rules: {
    rulesApiUrl: 'https://cmgclear2rulesengineapiappdev01.azurewebsites.net/api/v1',
    rulesHubUrl: 'https://cmgclear2rulesengineuiappdev01.azurewebsites.net/hub',
    isLiteMode: false,
    bearerToken:
      'AuVI-jTFGRUJcHEbHQqQ8REk6xRmZoSrjC5nVRjJ5I_61lxXrtL66h9BQzV1B84PzScR8He7x73Wm1r-EIioP8fq44Gvei5tb7xIgRrZuL2vAxXjNvRsYCQnyGw0Rg60acEv2-lpwucJlFKeEFvgmRNdsRPSqXmceJywJY4UNJwtPpqmSrUHdPgAL6RB8fH79Jvf8N5vgplSrKxjWtBKm_x8mHY_WO_zJjZEgqyOD-ezmsSrAh8RmqLsa8oqVt79NA2',
  },
  logoutWarning: {
    isActive: true,
    secondsInactivity: 40 * 60,
    secondsWindowCountdown: 5 * 60,
  },
  licenses: {
    /** For AG Grid - Enterprise version. */
    agGrid:
      'Using_this_AG_Grid_Enterprise_key_( AG-051166 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( CMG Financial )_is_granted_a_( Single Application )_Developer_License_for_the_application_( CMGFI )_only_for_( 3 )_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_( CMGFI )_need_to_be_licensed___( CMGFI )_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 21_November_2024 )____[v2]_MTczMjE0NzIwMDAwMA==8fd2ce04a69a68f10f3455e3cca9c856',
  },
  auth: {
    useAzureAD: true,
    clientId: 'e7589b35-3380-43f7-b843-2fa3b8f032b7',
    tenantId: '57d88166-f247-4dee-a6f9-e6359f96ff2c',
    scopes: ['api://8afd1511-5ea3-4c48-91df-a1073a855774/access_as_user'],
  },
  logRocket: {
    enabled: true,
    applicationId: '2pv18v/clear-20-dev',
  },
  appInsights: {
    applicationName: 'Clear 2.0 Web',
    connectionString:
      'InstrumentationKey=be8f9688-c73a-4242-b141-c6afb8278514;IngestionEndpoint=https://westus2-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westus2.livediagnostics.monitor.azure.com/',
    excludedRegexes: ['^.*2pv18v.*$', '^.*r.lr-in-prod.com.*$', '^.*r.lr-ingest.io.*$'],
  },
  featureFlagPollingDelay: 2 * 60 * 60 * 1000,
  versionUpdatePollingDelay: 1 * 60 * 1000,
  serviceWorkerEnabled: true,
  serviceWorkerRegistrationDelay: 30 * 1000,
  securityProfileId: {
    Admin: 1000001,
    SuperDisclosureLO: 1000154,
    DisclosureLO: 1000153,
    DisclosurePA: 1000158,
    SuperDisclosurePA: 1000159,
    SuperDisclosureLORelo: 1000161,
    AdminLaptop: 1000146,
    DisclosureCoordinator: 1000006,
    ProductionAssistant: 1000063,
  },
  enableAmcProviderForDivision: 'New England Operations',
  partners: {
    coBrandingApplicationBaseUrl: 'https://dev.secure.cmghomeloans.com',
  },
  clearAiHubUrl: 'https://cmgaihubappdev01.azurewebsites.net/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
